export const ADMIN_CLIP_PAGE_SIZE = 12;

function filterClipsByQuery(clips, query) {
	const q = (query ?? "").trim().toLowerCase();
	if (!q) {
		return clips;
	}
	return clips.filter(
		(clip) =>
			(clip.title ?? "").toLowerCase().includes(q) ||
			(clip.description ?? "").toLowerCase().includes(q)
	);
}

function paginateClipList(list, page, pageSize) {
	const total_count = list.length;
	const max_page = Math.max(1, Math.ceil(total_count / pageSize));
	const safePage = Math.min(Math.max(1, page), max_page);
	const start = (safePage - 1) * pageSize;
	return {
		clips: list.slice(start, start + pageSize),
		max_page,
		page: safePage,
		total_count,
	};
}

/** Legacy API returns a bare array; paginate/filter on the client. */
export function normalizeAdminClipListResponse(
	result,
	{ page = 1, query = "", focusClipId } = {}
) {
	if (Array.isArray(result)) {
		const filtered = filterClipsByQuery(result, query);
		let targetPage = page;
		if (focusClipId != null && focusClipId !== "") {
			const idx = filtered.findIndex(
				(clip) => String(clip.id) === String(focusClipId)
			);
			if (idx >= 0) {
				targetPage = Math.floor(idx / ADMIN_CLIP_PAGE_SIZE) + 1;
			}
		}
		return paginateClipList(filtered, targetPage, ADMIN_CLIP_PAGE_SIZE);
	}
	const clips = result?.clips ?? [];
	return {
		clips,
		max_page: result?.max_page ?? 1,
		page: result?.page ?? page,
		total_count: result?.total_count ?? clips.length,
	};
}
